import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';


import {
  HeaderComponent,
  FooterComponent,
  SidebarComponent,
  CodeRenderComponent
} from './components'
import { HighlightService } from './services/highligh.service';

const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SidebarComponent,
  CodeRenderComponent,
];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  exports: [
    COMPONENTS,
  ],
  providers: [
    HighlightService
  ]
})

export class ThemeModule { }
